const TOOL_MESSAGES = {
  list_catalog_schema: 'Browsing the catalog...',
  parse_dql: 'Parsing DQL...',
  execute_blueprint: 'Running the blueprint...',
  propose_blueprint_change: 'Preparing a proposal...'
}

function snapshotWorkspace (workspaceContext) {
  if (!workspaceContext) return { blueprintInfo: '', draft: '' }

  const { blueprintId, blueprintCode, displayName, draft } = workspaceContext

  const blueprintInfo = (blueprintId || blueprintCode || displayName)
    ? JSON.stringify({
      blueprintId: blueprintId || null,
      code: blueprintCode || null,
      displayName: displayName || null
    })
    : ''

  const draftSerialized = draft ? JSON.stringify(draft) : ''

  return { blueprintInfo, draft: draftSerialized }
}

function snapshotToAttachments (snapshot) {
  const attachments = []
  if (snapshot.blueprintInfo) attachments.push({ name: 'blueprintInfo', content: snapshot.blueprintInfo })
  if (snapshot.draft) attachments.push({ name: 'currentDefinition', content: snapshot.draft })
  return attachments
}

// Skips re-sending unchanged context. Same contract as the SmartEndpoints tracker.
export function createAttachmentTracker () {
  let lastSent = null

  return {
    buildAttachments (workspaceContext) {
      const current = snapshotWorkspace(workspaceContext)

      if (lastSent &&
        current.blueprintInfo === lastSent.blueprintInfo &&
        current.draft === lastSent.draft) {
        return []
      }

      lastSent = current
      return snapshotToAttachments(current)
    },

    reset () {
      lastSent = null
    }
  }
}

export const AGENT_CONFIGS = {
  'blueprint-designer': {
    agentId: 'blueprint-designer',
    label: 'Blueprint Designer',
    placeholder: 'Describe the data and presentation you want...',
    editPlaceholder: 'Describe what you want to change...',
    toolMessages: TOOL_MESSAGES
  }
}

export function getAgentConfig (agentId) {
  return AGENT_CONFIGS[agentId] || AGENT_CONFIGS['blueprint-designer']
}
